import { render, staticRenderFns } from "./RadioButtonConfig.vue?vue&type=template&id=7253669e&scoped=true"
import script from "./RadioButtonConfig.vue?vue&type=script&lang=js"
export * from "./RadioButtonConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253669e",
  null
  
)

export default component.exports